import { getToken } from "@dono-business/shared/utils";
import React from "react";
import { Navigate } from "react-router";

export const ProtectedRoute = ({ children }: { children: JSX.Element }) =>
    getToken() ? children : <Navigate to={"/login"} />;
